export default __webpack_public_path__ + "static/media/butterfly.0a9d8489.png";